module.exports = __webpack_public_path__ + "static/img/ZFlogo.8f6ffe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ZFlogo.png
// module id = 6enJ
// module chunks = 17